import { defineComponent as F, openBlock as r, createElementBlock as _, Fragment as v, renderList as x, normalizeClass as l, createElementVNode as h, createBlock as t, unref as c, withCtx as d, createVNode as i, createTextVNode as o, toDisplayString as m, createCommentVNode as w, resolveDynamicComponent as k } from "vue";
import N from "./ghl-ui.es622.js";
import "./ghl-ui.es55.js";
import "./ghl-ui.es623.js";
import P from "./ghl-ui.es204.js";
import B from "./ghl-ui.es81.js";
import C from "./ghl-ui.es345.js";
const D = ["onClick"], I = { class: "flex gap-1" }, R = { class: "dropdown-tree__item--path" }, S = { class: "dropdown-tree__item--label" }, T = {
  key: 0,
  class: "dropdown-tree__item--icon"
}, V = F({
  __name: "DropdownItem",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    showPath: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onForwardTraverse", "onSelect"],
  setup(a, { emit: b }) {
    const u = b, y = (s) => {
      var n;
      !s.disabled && ((n = s.children) != null && n.length) ? u("onForwardTraverse", s) : u("onSelect", s.value);
    }, g = (s) => s ? s == null ? void 0 : s.split("/").filter(Boolean).at(-1) : null;
    return (s, n) => (r(!0), _(v, null, x(a.options, (e) => {
      var f;
      return r(), _("a", {
        key: e.label.toString(),
        class: l(["dropdown-tree__item", [e == null ? void 0 : e.className, e.disabled ? "disabled" : ""]]),
        onClick: () => y(e)
      }, [
        h("span", I, [
          a.showPath && e._pathFromRoot !== "/" ? (r(), t(c(B), {
            key: 0,
            disabled: !a.showPath && e._pathFromRoot
          }, {
            trigger: d(() => [
              h("span", R, [
                i(c(C), {
                  class: "dropdown-tree__item--path-label",
                  tooltip: !1
                }, {
                  default: d(() => [
                    o(m(g(e._pathFromRoot)), 1)
                  ]),
                  _: 2
                }, 1024),
                o(" " + m("/"))
              ])
            ]),
            default: d(() => [
              o(" " + m(e == null ? void 0 : e._pathFromRoot), 1)
            ]),
            _: 2
          }, 1032, ["disabled"])) : w("", !0),
          h("span", S, [
            (r(), t(k(e.icon), {
              class: l(e.iconClass)
            }, null, 8, ["class"])),
            i(c(C), {
              class: l(a.showPath ? "showPath" : ""),
              tooltip: !1
            }, {
              default: d(() => [
                o(m(e.label), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ])
        ]),
        (f = e.children) != null && f.length ? (r(), _("span", T, [
          e.customArrow ? (r(), t(k(e == null ? void 0 : e.customArrow), {
            key: 0,
            class: l(e == null ? void 0 : e.arrowClass)
          }, null, 8, ["class"])) : (r(), t(c(N), {
            key: 1,
            class: "chevron"
          }))
        ])) : w("", !0)
      ], 10, D);
    }), 128));
  }
}), q = /* @__PURE__ */ P(V, [["__scopeId", "data-v-1a36bdc0"]]);
export {
  q as default
};
